import Nav from "./nav"
import Card from "./card"
import ProductGallery from "./product-gallery"
import SearchForm from "./search-form"
import Slider from "./slider"

document.addEventListener("DOMContentLoaded", function () {
    Nav(jQuery)
    Card(jQuery)
    ProductGallery(jQuery)
    SearchForm(jQuery)
    Slider(jQuery)
})
